import React from 'react';
import {Map, List} from 'immutable';
import {withSystem, Atom} from '@packages/systems/wfdl';

import {TBoolean, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const FacebookPixel = Atom.createRender(({data, productId}) => {
  // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
  const facebookPixelId = data.facebookPixelId;
  // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
  const lazyLoad = data.lazyLoad;
  // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
  const isProductDetailPage = data.isProductDetailPage;

  if (!facebookPixelId) {
    return null;
  }

  const value = [
    `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?`,
    `n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;`,
    `n.push=n;n.loaded=!0;n.version='2.0';n.agent='plwebflow';n.queue=[];t=b.createElement(e);t.async=!0;`,
    `t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,`,
    `document,'script','https://connect.facebook.net/en_US/fbevents.js');`,
    lazyLoad ? `fbq('consent', 'revoke');` : '',
    `fbq('init', '${String(facebookPixelId)}');`, // this has been validated and escaped in the backend
    `fbq('track', 'PageView');`,
    // ViewContent is fired only for ecommerce product details pages
    isProductDetailPage && productId
      ? `fbq('track', 'ViewContent', {
      content_type: 'product_group',
      content_ids: ['${String(productId)}']
    });`
      : '',
  ].join('');

  return (
    // eslint-disable-next-line react/no-danger
    <script type="text/javascript" dangerouslySetInnerHTML={{__html: value}} />
  );
});

const staticBindings = Map({
  productId: List([
    Map({
      id: 'id',
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  showEmpty: false,
  render: FacebookPixel,
  staticBindings,
  fields: {
    facebookPixelId: withSystem({private: true}, TText),
    lazyLoad: withSystem({private: true}, TBoolean),
    isProductDetailPage: withSystem({private: true}, TBoolean),
  },
});

export default config;
